import React from 'react';
import { Table } from 'react-bootstrap';
import StakeholderParticipationsTableRow from './StakeholderParticipationsTableRow.jsx';

const StakeholderParticipationsTable = ({
  initiative,
  stakeholdersParticipations,
  isPreview,
}) => {
  return stakeholdersParticipations.length ? (
    <Table condensed hover>
      <thead>
        <tr>
          <th>Group / Individual</th>
          {initiative.completionTracked && (
            <React.Fragment>
              <th>Status</th>
              <th>
                <span className="sr-only">Actions</span>
              </th>
            </React.Fragment>
          )}
        </tr>
      </thead>
      <tbody>
        {stakeholdersParticipations.map((stakeholderParticipation) => (
          <StakeholderParticipationsTableRow
            key={stakeholderParticipation.id}
            isPreview={isPreview}
            initiative={initiative}
            stakeholderParticipation={stakeholderParticipation}
          />
        ))}
      </tbody>
    </Table>
  ) : null;
};

export default StakeholderParticipationsTable;
